<div class="buscador">
  <input id="buscador" [ngStyle]="{'width.px': inputWidth}" type="text" placeholder="Buscar" [(ngModel)]="textoBuscar" (keyup)="buscar()">
  <svg class="hs-lupa"><use xlink:href="#hs-lupa"></use></svg>
  <svg class="hs-close" [ngStyle]="{'display':textoBuscar!=''?'block':'none'}" (click)="limpiarTexto()"><use xlink:href="#icon-close"></use></svg>
</div>

